import React, { useState, useEffect, useRef } from "react";

interface LogoItem {
  logo_img: string;
  [key: string]: any;
}

interface LogoCarouselProps {
  title: string;
  apiEndpoint: string;              // API endpoint to fetch logos
  logoKey?: string;                 // field name for logo (default: "logo_img")
  backendUrl: string;               // from env
}

const LogoCarousel: React.FC<LogoCarouselProps> = ({
  title,
  apiEndpoint,
  logoKey = "logo_img",
  backendUrl,
}) => {
  const [logos, setLogos] = useState<LogoItem[]>([]);
  const [itemsPerRow, setItemsPerRow] = useState(0);
  const containerRef = useRef<HTMLDivElement | null>(null);

  // ✅ Fetch logos
  const fetchLogos = async () => {
    try {
      const response = await fetch(`${backendUrl}${apiEndpoint}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        mode: "cors",
      });
      const data = await response.json();
      if (data.status && Array.isArray(data.result)) {
        setLogos(data.result);
      }
    } catch (err) {
      console.error("Error fetching logos:", err);
    }
  };

  // ✅ Calculate items per row dynamically
  const updateItemsPerRow = () => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const cardWidth = 160; // tweak based on design
      setItemsPerRow(Math.floor(containerWidth / cardWidth));
    }
  };

  useEffect(() => {
    fetchLogos();
    updateItemsPerRow();
    window.addEventListener("resize", updateItemsPerRow);
    return () => window.removeEventListener("resize", updateItemsPerRow);
  }, []);

  const isFewLogos = itemsPerRow > 0 && logos.length < itemsPerRow;

  return (
    <section className="partner">
      <div className="container">
        <div className="container-partners-logos" ref={containerRef}>
          <h2 className="headingText">{title}</h2>

          {isFewLogos ? (
            // ✅ Static grid layout
            <div className="dynamic-grid-logos">
              {logos.map((logo, index) => (
                <div key={index} className="slide-partner">
                  <img src={logo[logoKey]} alt={`logo-${index}`} width="228" height="188" style={{ maxWidth:"100%", height:"auto"}} />
                </div>
              ))}
            </div>
          ) : (
            // ✅ Infinite scroll carousel
            <div className="slider">
              <div className="slide-track">
                {logos.map((logo, index) => (
                  <div className="slide-partner" key={index}>
                    <img src={logo[logoKey]} alt={`logo-${index}`} />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default LogoCarousel;
